module.exports = __webpack_public_path__ + "img/Teaching-Research Case - Medium Gray.7e73106d.png";